$(document).ready(function(){
    $(".overlaydiv, .closeimage").click(function(){
      $(".overlaydiv, .popupdiv").fadeOut();
    })
    $(".shopify-product-form a.delivery-popup").click(function(e){
      e.preventDefault();
      $(".overlaydiv, .deliveryp").fadeIn();
    })

      $(".shopify-product-form a.try-before").click(function(e){
      e.preventDefault();
      $(".overlaydiv, .trybeforep").fadeIn();
    })

    $(".shopify-product-form a.store-locations").click(function(e){
      e.preventDefault();
      $(".overlaydiv, .storep").fadeIn();
    })

    $(".shopify-product-form a.refund-policy-popup").click(function(e){
      e.preventDefault();
      $(".overlaydiv, .easyp").fadeIn();
    })
  })
